var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5L11 0.5H25.5L16 15.5H29.5L20 31.5H5.5L16 15.5H1Z",
    fill: "#01C670"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.5L25.5 0.5H11L1 15.5H16ZM16 15.5H29.5L20 31.5H5.5L16 15.5Z",
    stroke: "#5F6464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCertificate);
export default __webpack_public_path__ + "static/media/logo_certificate.4f3f3080ecbf92dc957204720c9adeed.svg";
export { ForwardRef as ReactComponent };